import {Component, Inject, OnInit} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { BackendApiService } from 'src/app/services/backend-api.service';
import { DocumentApiResources } from '../document.constants';
import { ToasterService } from 'src/app/services/core/toaster.service';
import {SettingDataService} from "src/app/modules/setting/setting.data.service";
import { DocumentService } from '../document.service';

@Component({
    selector: 'app-document-create-folder',
    templateUrl: './document-create-folder.component.html',
    styleUrls: ['./document-create-folder.component.scss'],
    standalone: false
})
export class DocumentCreateFolderComponent implements OnInit {
  public isSaving = false;

  private baseURL;
  private type: string = '';


  moduleOptions: Array<{ id: number; name: string }> = [];
  public createForm: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl(null, [Validators.required]),
    folder_id: new UntypedFormControl(null, []),
    scope_id: new UntypedFormControl(null, []),
    module_id: new UntypedFormControl(null, []),
    is_virtual: new UntypedFormControl(false),
    show_module_id_data: new UntypedFormControl('')
  })

  constructor(
    public dialogRef: MatDialogRef<DocumentCreateFolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public documentService: DocumentService,
    public backendApiService: BackendApiService,
    public toasterService: ToasterService,
     public SettingDataService: SettingDataService,
  ) {
    this.setFormData()
    this.baseURL = DocumentApiResources;
  }

  ngOnInit(): void {
    this.createForm.get('is_virtual')?.valueChanges.subscribe((isChecked: boolean) => {
      const dropdownControl = this.createForm.get('show_module_id_data');

      if (isChecked) {
        dropdownControl?.setValidators(Validators.required);
      } else {
        dropdownControl?.clearValidators();
      }

      dropdownControl?.updateValueAndValidity();
    });
    this.loadRelatedModules();
  }

  setFormData = () => {
    this.createForm?.setValue({
      name: "",
      folder_id: this.data?.folder_id,
      module_id:this.data?.module_id,
      scope_id: this.data?.scope_id ? this.data?.scope_id : null,
      is_virtual: false,
      show_module_id_data: ''
    });
}

  touchFormControls() {
    Object.keys(this.createForm.controls).forEach(key => {
      this.createForm.get(key)?.markAsTouched();
    });
  }
  close = (data: any = null) => {
    this.dialogRef.close(data);
  }

  save() {
    if(!this.createForm.invalid) {
      this.touchFormControls();

      let path = this.data.type == 'main' ? this.baseURL.createFolderDocument : this.baseURL.createFolderDocumentSetting;
      const payload: any = { ...this.createForm?.value };
      // In some detail roots (e.g. Jobsite), folder_id can be null.
      // Sending null triggers backend "folder required" validation; omit it instead.
      if (payload.folder_id === null || payload.folder_id === undefined || payload.folder_id === '') {
        delete payload.folder_id;
      }
      this.isSaving = true;
      this.backendApiService.postApi(path, payload)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe((response: any)=> {
        this.close(response?.data);
          this.toasterService.showSuccessMessage(response?.data?.message);
      })
    }
  }


  loadRelatedModules() {
    this.SettingDataService.getRelatedModulesByModuleId(this.data?.module_id , {})

      .subscribe((response: any) => {
        let data = response.data;
       const unrelated = this.documentService.unrelatedModules();
       const currentModuleId = this.data?.module_id;
       if (unrelated[currentModuleId]) {
        const unrelatedIds = unrelated[currentModuleId];
        data = data.filter((item: any) => !unrelatedIds.includes(item.id));
      }

        this.moduleOptions = data
      });
  }

}
